import { c as _c } from "react/compiler-runtime";
import { getRoleEntityTags } from '@onefootprint/core';
import type { OrganizationRole } from '@onefootprint/request-types/dashboard';
import { Tag } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import Actions from './components/actions';
import Scopes from './components/scopes';
export type RowProps = {
  role: OrganizationRole;
  isMobile?: boolean;
};
const Row = t0 => {
  const $ = _c(60);
  const {
    role,
    isMobile
  } = t0;
  const {
    t
  } = useTranslation("roles");
  const {
    name,
    scopes,
    isImmutable,
    createdAt,
    numActiveUsers,
    numActiveApiKeys
  } = role;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== createdAt || $[1] !== isImmutable || $[2] !== isMobile || $[3] !== name || $[4] !== numActiveApiKeys || $[5] !== numActiveUsers || $[6] !== role || $[7] !== scopes || $[8] !== t) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const entityTags = getRoleEntityTags(scopes);
      if (isMobile) {
        let t7;
        if ($[15] !== numActiveApiKeys || $[16] !== numActiveUsers || $[17] !== role.kind || $[18] !== t) {
          t7 = role.kind === "api_key" ? `${t(_temp)}: ${numActiveApiKeys}` : `${t(_temp2)}: ${numActiveUsers}`;
          $[15] = numActiveApiKeys;
          $[16] = numActiveUsers;
          $[17] = role.kind;
          $[18] = t;
          $[19] = t7;
        } else {
          t7 = $[19];
        }
        const activeCount = t7;
        let t8;
        if ($[20] !== name) {
          t8 = <p className="text-label-2 text-primary">{name}</p>;
          $[20] = name;
          $[21] = t8;
        } else {
          t8 = $[21];
        }
        let t9;
        if ($[22] !== activeCount || $[23] !== createdAt) {
          t9 = <p className="text-body-3 text-tertiary">{activeCount} · {createdAt}</p>;
          $[22] = activeCount;
          $[23] = createdAt;
          $[24] = t9;
        } else {
          t9 = $[24];
        }
        let t10;
        if ($[25] !== scopes) {
          t10 = <Scopes scopes={scopes} />;
          $[25] = scopes;
          $[26] = t10;
        } else {
          t10 = $[26];
        }
        const t11 = <td><div className="flex min-w-0 flex-col gap-1 py-3 whitespace-normal">{t8}{t9}{t10}{entityTags && entityTags.length > 0 && <div className="flex flex-row flex-wrap items-center gap-1"><span className="text-caption-2 text-tertiary">{t(_temp3)}</span>{entityTags.map(_temp4)}</div>}</div></td>;
        let t12;
        if ($[27] !== isImmutable || $[28] !== role) {
          t12 = isImmutable ? null : <Actions role={role} />;
          $[27] = isImmutable;
          $[28] = role;
          $[29] = t12;
        } else {
          t12 = $[29];
        }
        let t13;
        if ($[30] !== t12) {
          t13 = <td>{t12}</td>;
          $[30] = t12;
          $[31] = t13;
        } else {
          t13 = $[31];
        }
        let t14;
        if ($[32] !== t11 || $[33] !== t13) {
          t14 = <>{t11}{t13}</>;
          $[32] = t11;
          $[33] = t13;
          $[34] = t14;
        } else {
          t14 = $[34];
        }
        t6 = t14;
        break bb0;
      }
      if ($[35] !== name) {
        t4 = <td>{name}</td>;
        $[35] = name;
        $[36] = t4;
      } else {
        t4 = $[36];
      }
      if ($[37] !== numActiveApiKeys || $[38] !== numActiveUsers || $[39] !== role.kind) {
        t5 = role.kind === "api_key" ? <td>{numActiveApiKeys}</td> : <td>{numActiveUsers}</td>;
        $[37] = numActiveApiKeys;
        $[38] = numActiveUsers;
        $[39] = role.kind;
        $[40] = t5;
      } else {
        t5 = $[40];
      }
      t1 = "scopes";
      if ($[41] !== scopes) {
        t2 = <Scopes scopes={scopes} />;
        $[41] = scopes;
        $[42] = t2;
      } else {
        t2 = $[42];
      }
      t3 = entityTags && entityTags.length > 0 && <div className="flex flex-row flex-wrap items-center gap-1 pb-2"><span className="text-caption-2 text-tertiary">{t(_temp5)}</span>{entityTags.map(_temp6)}</div>;
    }
    $[0] = createdAt;
    $[1] = isImmutable;
    $[2] = isMobile;
    $[3] = name;
    $[4] = numActiveApiKeys;
    $[5] = numActiveUsers;
    $[6] = role;
    $[7] = scopes;
    $[8] = t;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[43] !== t1 || $[44] !== t2 || $[45] !== t3) {
    t7 = <td aria-label={t1}>{t2}{t3}</td>;
    $[43] = t1;
    $[44] = t2;
    $[45] = t3;
    $[46] = t7;
  } else {
    t7 = $[46];
  }
  let t8;
  if ($[47] !== createdAt) {
    t8 = <td>{createdAt}</td>;
    $[47] = createdAt;
    $[48] = t8;
  } else {
    t8 = $[48];
  }
  let t9;
  if ($[49] !== isImmutable || $[50] !== role) {
    t9 = isImmutable ? null : <Actions role={role} />;
    $[49] = isImmutable;
    $[50] = role;
    $[51] = t9;
  } else {
    t9 = $[51];
  }
  let t10;
  if ($[52] !== t9) {
    t10 = <td>{t9}</td>;
    $[52] = t9;
    $[53] = t10;
  } else {
    t10 = $[53];
  }
  let t11;
  if ($[54] !== t10 || $[55] !== t4 || $[56] !== t5 || $[57] !== t7 || $[58] !== t8) {
    t11 = <>{t4}{t5}{t7}{t8}{t10}</>;
    $[54] = t10;
    $[55] = t4;
    $[56] = t5;
    $[57] = t7;
    $[58] = t8;
    $[59] = t11;
  } else {
    t11 = $[59];
  }
  return t11;
};
export default Row;
function _temp($) {
  return $.table.header.activeApiKeys;
}
function _temp2($_0) {
  return $_0.table.header.activeUsers;
}
function _temp3($_1) {
  return $_1.entityTags.label;
}
function _temp4(tag) {
  return <Tag key={tag}>{tag}</Tag>;
}
function _temp5($_2) {
  return $_2.entityTags.label;
}
function _temp6(tag_0) {
  return <Tag key={tag_0}>{tag_0}</Tag>;
}